(() => {
  const path = window.location.pathname;
  const valid = value => typeof value === 'string' && /^\/products\/[a-zA-Z0-9_-]+$/.test(value);
  let destination = '/collections/all';
  try {
    if (valid(path)) sessionStorage.setItem('isaid-offer-product', path);
    const saved = sessionStorage.getItem('isaid-offer-product');
    if (valid(saved)) destination = saved;
  } catch { /* Privacy-mode storage restrictions keep the catalog fallback. */ }
  document.querySelectorAll('[data-isaid-keep-five]').forEach(link => {
    link.href = '/discount/ISAID5?redirect=' + encodeURIComponent(destination);
  });
  if (path === '/pages/offer-success') window.location.replace(destination);
})();
